import {HorizontalDivider, RemixCard, Box} from '@ttx/design-system';
import React from 'react';
import {useMusicPlayer} from '../../contexts/music-player-context/music-player-context';

export const RemixCardScroll = ({remixCardData}: any) => {
  const {
    setAudioSrc,
    isPlaying,
    isLoading,
    currentTime,
    setCurrentTime,
    audioPlayer,
    togglePlayPause,
    audioSrc,
    setIsPlaying,
  } = useMusicPlayer();
  return (
    <>
      <Box flexDirection="row" width="100%" overflowX="scroll">
        {remixCardData?.map((remixCard: any, idx: number) => {
          return (
            <Box
              width={288}
              height="100%"
              borderRightColor="outlines"
              borderRightStyle="solid"
              borderRightWidth={idx !== remixCardData.length ? 'one' : 'zero'}
              borderTopWidth="zero"
              borderBottomWidth="zero"
              key={`${idx.toString()}`}
            >
              <RemixCard
                artist={remixCard.artist}
                songTitle={remixCard.songTitle}
                imageSrc={remixCard.imageSrc}
                audioSrc={remixCard.audioSrc}
                currentAudio={audioSrc}
                setAudioSrc={setAudioSrc}
                isLoading={isLoading && remixCard.audioSrc === audioSrc}
                isPlaying={isPlaying && remixCard.audioSrc === audioSrc}
                setCurrentTime={setCurrentTime}
                currentTime={currentTime}
                togglePlayPause={togglePlayPause}
                audioPlayer={audioPlayer}
                setIsPlaying={setIsPlaying}
              />
            </Box>
          );
        })}
      </Box>
      <HorizontalDivider />
    </>
  );
};
